import CustomerReciept from "./CustomerReciept";

export { CustomerReciept }